import { render, staticRenderFns } from "./EnforcementNotes.vue?vue&type=template&id=ef925c2c&scoped=true&"
import script from "./EnforcementNotes.vue?vue&type=script&lang=js&"
export * from "./EnforcementNotes.vue?vue&type=script&lang=js&"
import style0 from "./EnforcementNotes.vue?vue&type=style&index=0&id=ef925c2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef925c2c",
  null
  
)

export default component.exports